import type { SVGProps } from 'react'
const LineFaceSmile = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M2 12c0 5.515 4.485 10 10 10s10-4.485 10-10S17.515 2 12 2 2 6.485 2 12m1.5 0c0-4.685 3.815-8.5 8.5-8.5s8.5 3.815 8.5 8.5-3.815 8.5-8.5 8.5-8.5-3.815-8.5-8.5M17 9.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M8.5 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m-.395 3.25A4.5 4.5 0 0 0 12 16.5h.01c1.6 0 3.095-.865 3.895-2.25l-1.3-.75a3.01 3.01 0 0 1-2.6 1.5 3.01 3.01 0 0 1-2.6-1.5z"
			clipRule="evenodd"
		/>
	</svg>
)
export { LineFaceSmile }
